import { parseQuery } from './QueryString';

// Guest payment links carry the ExternalLogin token in the path (/makeAPayment/<token>) or, in
// links already sitting in customers' inboxes, as ?token=. The path form survives a merchant's domain
// forwarder that drops the query string (TD1-10712); both must keep working.
export const makeAPaymentToken = (pathname = '', search = '') => {
  const match = pathname.match(/^\/makeAPayment\/([^/]+)\/?$/);
  if (match) return decodeURIComponent(match[1]);

  // Only the payment page reads ?token= — other pages (password reset) carry an unrelated token.
  return /^\/makeAPayment\/?$/.test(pathname) ? parseQuery(search).token : undefined;
};
